<template>
  <div class="meeting">
    <advertising-figure :bannerSrc="bannerSrc"/>
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Inform of the meeting</span>
      </public-title>
      <div class="list-wrap">
        <div
          class="list"
          v-for="(item, i) in currentConference.informs"
          :key="i"
        >
          <div class="high">
            <h2 class="tit">{{ item.name }}</h2>
            <span @click="jumpTo(item)">查看详情</span>
          </div>
          <span class="time">发布日期: 2022-1-15</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import PublicTitle from "@components/title"
  import CurrentConferMixin from "@/mixin/CurrentConference"

  export default {
    name: "MeetingDetails",
    components: {
      PublicTitle,
      AdvertisingFigure,
      InnerPageNav,
    },
    mixins: [CurrentConferMixin],
    data() {
      return {
        bannerSrc:require("@assets/img/meeting-banner.png"),
        title: "会议通知",
      }
    },

    methods: {
      jumpTo(item) {
        this.$router.push({
          name: "informDetailPage",
          params: { inform: item },
          query: { inform_id: item.id },
        })
      },
      getInfo() {
        console.log(this.$route.params)
      },
    },
    watch: {
      $route: "getInfo",
    },
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";

  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .list {
    @include flex-between;
    width: 1200px;
    height: 50px;
    padding: 0 15px;
    margin: 30px auto;
    border-bottom: 1px solid #eee;

    .high {
      height: 100%;

      span {
        font-size: 12px;
        text-align: center;
        color: $defaultColor;
        cursor: pointer;
      }
    }

    .tit {
      position: relative;
      font-size: 18px;
      color: #666;
      font-weight: normal;
      margin-bottom: 5px;
    }

    .time {
      font-size: 14px;
      color: #999;
    }
  }
</style>
